// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"4fb5e004","54":"3ee09e52","423":"1169f4a9","484":"69afa1a5","896":"2d491294","964":"528c5c20"}[chunkId] + ".css";
};